import { TrecordId, TMyRecordType, TMyLiveType } from "@/module/myCourse";
import request from "@/utils/requset";
import { TResponse, TTotal } from "@/module/common"

// 我的课程（录播）
export const getRecordCourse = (data: TrecordId) => {
    return request<TrecordId, TTotal<TMyRecordType[]>>({
        url: '/api/user/structuredirectory/getuserbycurriculum',
        method: 'GET',
        data
    })
}

// 我的课程（直播）
export const getLiveCourse = (data: TrecordId) => {
    return request<TrecordId, TTotal<TMyLiveType[]>>({
        url: '/api/user/liveplaydirectory/getuserbycurriculum',
        method: 'GET',
        data
    })
}